export const NAME = 'FlightAlerts';



// WEBPACK FOOTER //
// ./modules/FlightAlerts/redux/Current/constants.js